<template>
    <div class="d-flex flex-column justify-center">
        <v-btn
            color="primary"
            @click="openConfirmModal"
        >
            Gerar cartão Blue
        </v-btn>
        <v-dialog
            v-model="confirmModal"
            persistent
            max-width="600"
        >
            <v-card>
                <v-card-title class="title">
                    <v-icon size="md" color="white">mdi-alert</v-icon>
                    <span class="ml-2">Tem certeza que deseja gerar o cartão Blue?</span>
                </v-card-title>
                <v-card-text class="py-4">
                    <span>O cartão atual será cancelado e um cartão Blue será gerado.</span>
                </v-card-text>
                <v-card-actions class="justify-end pb-4">
                    <v-btn
                        color="error"
                        @click="closeConfirmModal"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        class="ml-2"
                        color="success"
                        :loading="loading"
                        @click="createBlueVirtualCard()"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <response-dialog
            :model="responseModal"
            :message="responseMessage"
            :type="responseType"
            @close="closeAndReload()"
        />
    </div>
</template>

<script>
import ResponseDialog from "../../../components/Dialog/ResponseDialog.vue";

export default {
    name: "CreateBlueCard",
    components: {ResponseDialog},
    data: () => ({
        loading: false,
        confirmModal: false,
        responseModal: false,
        responseMessage: '',
        responseType: '',
    }),
    props: {
        bookingId: {
            type: Number,
            required: true
        }
    },
    methods: {
        openConfirmModal() {
            this.confirmModal = true;
        },
        closeConfirmModal() {
            this.confirmModal = false;
        },
        openResponseModal(type, message) {
            this.responseType = type;
            this.responseMessage = message;
            this.responseModal = true;
        },
        createBlueVirtualCard() {
            this.loading = true;
            axios.post('/api/card/create-blue/' + this.bookingId,
                {
                    headers: {
                        ContentType: 'application/json'
                    }
                })
                .then((res) => {
                    this.openResponseModal('success', res.data.message);
                })
                .catch((err) => {
                    this.openResponseModal('error', err.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
        },
        closeAndReload() {
            this.responseModal = false;
            this.confirmModal = false;
            window.location.reload();
        },
    }
}
</script>

<style scoped>
.title {
    background-color: #fb8c00;
    color: white;
    font-weight: bold;
}
</style>